import React from "react";

export default function FadeOutOverlay() {
  return <div className="FadeOutOverlay" />;
}
